<!-- <app-topbar></app-topbar>
<app-breadcrumbs></app-breadcrumbs>
<app-sidebar></app-sidebar>
<section class="content">
    <router-outlet></router-outlet>
</section>   -->

<!-- <ng-progress [color]="'#1abc9c'"></ng-progress> -->
<!-- <notification></notification> -->
<router-outlet></router-outlet>